import { render, staticRenderFns } from "./processAffair.vue?vue&type=template&id=162a0a0d&"
import script from "./processAffair.vue?vue&type=script&lang=js&"
export * from "./processAffair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports